import React from 'react';
import { Box, Typography } from '@mui/material';
import Tooltip from 'components/Tooltip';
import Icon from 'components/Icon';

type StatsItemProps = {
  label: string;
  value: React.ReactNode;
  tooltip?: string;
};

const StatsItem = ({ value, label, tooltip }: StatsItemProps) => (
  <Box>
    <Typography
      sx={{
        color: 'text.secondary',
        marginRight: tooltip ? 0.5 : 2,
      }}
      component="span"
    >
      {label}:
    </Typography>
    {tooltip && (
      <Tooltip placement="top" title={tooltip}>
        <Icon
          name="question"
          aria-label={`${label} info`}
          sx={{
            fontSize: 14,
            color: 'text.secondary',
            cursor: 'help',
            verticalAlign: 'middle',
            mr: 1,
          }}
        />
      </Tooltip>
    )}
    <span>{value}</span>
  </Box>
);

export default StatsItem;
